import { AbstractControl, ValidatorFn, ValidationErrors } from '@angular/forms';
import { byteLength } from './byte-length.function';

export function byteMaxValidator (max: number): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
        const length: number = control.value ? byteLength(control.value) : 0;
        if (length > max) {
            return {maxByte:{length, max}};
        }
        return null;
    };
}
